<template>
	<div>
		<el-select
			size="mini"
			v-model="myValue"
			:placeholder="'请选择'+fieldInfo.show_name"
			clearable
			value-key="index"
		>
			<el-option
				:label="enumName"
				:value="enumName"
				v-for="(enumName) in list"
				:key="enumName"
			></el-option>
		</el-select>
	</div>
</template>
<script>
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],

	data() {
		return {};
	},
	props: {
		dataModelName: {
			type: String,
			default: "User"
		},
		field: {
			type: String,
			default: ""
		},
		value: {
			type: [Number, String],
			default: null
		},
		list:{
			type: Array,

		}
	},
	computed: {
		myValue: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			}
		},
		fieldInfo() {
			if (this.hasGetTableDataModel && this.field != "") {
				return JSON.parse(JSON.stringify(this.dataModels[this.dataModelName][this.field]));
			}
			return { enum: [], show_name: "" };
		}
	},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
